import styled, { css } from 'styled-components';
import { ellipsis } from '../../../../styles/mixins.ts';

export const ModalHeaderContainer = styled.div<{ removeShadow?: boolean }>`
  height: 56px;
  box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #fff;
  position: relative;
  ${({ theme }) => theme.kallisto.mixins.font('Title5')};

  svg {
    line {
      stroke: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
      stroke-width: 1;
    }
  }

  ${({ removeShadow }) =>
    removeShadow &&
    css`
      box-shadow: unset;
      border-bottom: 1px solid ${({ theme }) => theme.kallisto.color.common.black[50]};
    `}
`;

export const BasicTitleContainer = styled.div<{ removeShadow?: boolean }>`
  padding-left: 52px;
  padding-right: 52px;
  ${ellipsis};
`;

export const CloseIconContainer = styled.button<{ $closeOnRight?: boolean }>`
  position: absolute;
  ${({ $closeOnRight }) => ($closeOnRight ? 'right: 16px;' : 'left: 16px;')}
  cursor: pointer;
  z-index: 2;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: 0;
  background: unset;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};

  &:focus-visible {
    border-radius: 2px;
  }

  svg {
    flex-shrink: 0;
  }
`;
